<div fxLayout>
  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2>
      Your account owner needs to connect at least one channel before you can use {{ 'CORE.PRODUCT_NAME' | transloco }}.
    </h2>

    <h2>Ask them to connect a channel to continue.</h2>
  </main>
</div>
